// @flow

import React from 'react'
import styled from 'styled-components'
// $FlowFixMe
import { components } from 'react-select'
import { StyledP } from 'src/theme/globalStyle'
import { roundToTwo } from 'src/helpers/normalize'

type Props = {
  data: {
    value: number,
    weeklyPrice: number
  }
}

const StyledLabel = styled.label`
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  color: ${props => props.theme.darkText};
`

const Option = (props: Props) => {
  const {
    data: { value, weeklyPrice }
  } = props
  return (
    <components.Option {...props}>
      <StyledP>{`${value} months – £${weeklyPrice} per week `}</StyledP>
      <StyledLabel>{`You’ll pay a single monthly bill of £ ${roundToTwo(
        (52 * weeklyPrice) / 12
      )}`}</StyledLabel>
    </components.Option>
  )
}

export default Option



// WEBPACK FOOTER //
// ./src/containers/RoomDetailForm/components/CustomOption.js